var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0E11",
    d: "M13 6.5c0 1.435-.465 2.76-1.25 3.835l3.957 3.96a1.001 1.001 0 0 1-1.416 1.415l-3.956-3.96A6.463 6.463 0 0 1 6.5 13 6.5 6.5 0 0 1 0 6.5 6.5 6.5 0 0 1 6.5 0 6.5 6.5 0 0 1 13 6.5ZM6.5 11a4.501 4.501 0 1 0 0-9.002 4.501 4.501 0 0 0 0 9.003Z"
  })));
};
export default SvgSearch;